import Box from '@mui/material/Box'

export function Image({ src, alt, sx, ...props }) {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        maxWidth: '100%',
        height: 'auto',
        ...sx,
      }}
      {...props}
    />
  )
}
